export default {
  updateDate: 'Update Date',
  status: 'Status',
  plant: 'Plant',
  platformOrderNo: 'Platform Order No',
  giOrderNo: 'GI Order No',
  rfidEpc: 'RFID EPC',
  carrierTrackingNo: 'Carrier Tracking No',
  requiredBingQty: 'Required Bind Qty',
  actualTotalBinds: 'Actual Total Binds',
  rfidBinds: 'RFID Binds',
  qrBinds: 'QR Binds',
  device: 'Device',
  carton: 'Carton',
  sku: 'SKU',
  totalCartonQty: 'Total Carton Qty',
  bindCartonQty: 'Bind Carton Qty',
  unbindCartonQty: 'Unbind Carton Qty',
  totalSkuQty: 'Total SKU Qty',
  bindSkuQty: 'Bind SKU Qty',
  unbindSkuQty: 'Unbind SKU Qty',
  date: 'Date',
  definition1: `
    <b>Status Signal (Report Left)</b>: 
    Transparent - Product has never been bound; Blue - Product is in the binding process; Green - Product has been successfully bound; Orange - Force-bound; Gray - Product has been unbound.`,
  definition2: `
    <b>RFID EPC/QR Code Strikethrough</b>: 
    This indicates that the product has been unbound from the order number.`
}
